import { render, staticRenderFns } from "./BaseLearningPathPicker.vue?vue&type=template&id=506390f6&"
import script from "./BaseLearningPathPicker.vue?vue&type=script&lang=js&"
export * from "./BaseLearningPathPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506390f6')) {
      api.createRecord('506390f6', component.options)
    } else {
      api.reload('506390f6', component.options)
    }
    module.hot.accept("./BaseLearningPathPicker.vue?vue&type=template&id=506390f6&", function () {
      api.rerender('506390f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseLearningPathPicker.vue"
export default component.exports